module.exports = {"name":"Tlačidlo na pridanie článku","icon":"<i class='material-icons'>note_add</i>","widget":{"type":"article-new-button","initData":{"title":"Vytvoriť"}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/article-new-button/article-new-button.json
// module id = 299
// module chunks = 0